<script>
import VImportantDateForm from "@/components/Forms/VImportantDateForm";
import ImportantDateService from "@/services/ImportantDateService";
import { mapGetters } from "vuex";
import VContextComments from "@/components/Planning/Helpers/VContextComments";
import { EventBus } from "@/libraries/EventBus";
import VControl from "@/components/Planning/Helpers/VControl";
import VInlineEdit from "./VInlineEdit.vue";

export default {
    props: {
        project_id: {}
    },
    components: { VImportantDateForm, VContextComments, VControl, VInlineEdit },
    data() {
        return {
            loading: true,
            showForm: false,
            dates: [],
            meta: {},
            selectedFilter: "upcoming",
            showSection: true,
            context: {},
            suSaving: false,
            suError: "",
            showIDCol: false
        };
    },
    computed: {
        ...mapGetters("auth", ["getMyId"])
    },
    async created() {
        this.apiPaginator.sort = "ImportantDates.date_start";
        this.apiPaginator.direction = "asc";
        // this.apiSearchFilter = {
        //     search: "",
        //     favorites_user_id: null,
        //     invoice_setup: this.getInvoiceSetup,
        // };
        // this.$apiEnableWatcher();
        await this.fetchData();
        this.loading = false;
        EventBus.$on("journal-refresh", this.fetchData);
        EventBus.$on("data-tab-open", () => {
            this.showSection = true;
        });
        EventBus.$on("data-tab-close", () => {
            this.showSection = false;
        });
    },
    beforeDestroy() {
        EventBus.$off("journal-refresh", this.fetchData);
        EventBus.$off("data-tab-open");
        EventBus.$off("data-tab-close");
    },
    methods: {
        async fetchData() {
            try {
                let params = this.$buildParams();
                params["project_id"] = this.project_id;
                params["filter"] = this.selectedFilter;
                const { data } = await ImportantDateService.GET(params);
                this.dates = data.data;
                this.meta = data.meta;
            } catch (e) {
                console.log("fde", e);
            }
        },
        async updateText(item, new_text) {
            try {
                this.suSaving = true;
                this.suError = "";
                const data = {
                    id: item.id,
                    description: new_text
                };

                await ImportantDateService.PUT(data);
                await this.fetchData();
            } catch (e) {
                console.log("E updateText", e);
                this.suError = e.response.data.errors;
            }

            this.suSaving = false;
        },
        closeReload() {
            this.fetchData();
            this.showForm = false;
        },
        setContext(ctx) {
            this.context = ctx;
            this.showForm = true;
        },
        isPast(id) {
            const now = new Date();
            let compare;

            if (id.date_end) {
                compare = id.date_end;
            } else {
                compare = id.date_start;
            }

            if (now > new Date(compare)) {
                return true;
            } else {
                return false;
            }
        },
        filter(filterAction) {
            this.selectedFilter = filterAction;
            this.apiPaginator.page = null;
            this.fetchData();
        }
    }
};
</script>

<template>
    <div class="v-important-dates">
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <div class="mb-3">
                        <v-control
                            :show="showSection"
                            @trigger="showSection = !showSection"
                        >
                            <h3 class="pb-0 mb-0">
                                {{ $t("important_dates.important_dates") }}
                            </h3>
                        </v-control>
                    </div>
                    <template v-if="showSection">
                        <v-loader :loading="loading" v-if="loading" />
                        <card body-classes="px-0" v-else>
                            <div class="mx-4 mb-3 d-flex justify-content-end">
                                <div>
                                    <base-button
                                        size="sm"
                                        :type="
                                            selectedFilter == 'upcoming'
                                                ? 'primary'
                                                : 'secondary'
                                        "
                                        @click="filter('upcoming')"
                                        >{{
                                            $t("actions.filter_active")
                                        }}</base-button
                                    >

                                    <base-button
                                        size="sm"
                                        :type="
                                            selectedFilter == 'all'
                                                ? 'primary'
                                                : 'secondary'
                                        "
                                        @click="filter('all')"
                                        >{{
                                            $t("actions.filter_all")
                                        }}</base-button
                                    >
                                    <span
                                        v-if="false"
                                        @click="showIDCol = !showIDCol"
                                        class="m-click text-primary ml-2 mr-2"
                                        ><i
                                            class="fas fa-fw"
                                            :class="{
                                                'fa-eye': showIDCol,
                                                'fa-eye-slash': !showIDCol
                                            }"
                                        ></i>
                                        ID</span
                                    >
                                </div>
                            </div>

                            <template v-if="dates.length > 0">
                                <v-table class="table table-mg table-sm">
                                    <v-thead>
                                        <v-tr>
                                            <v-th
                                                class="hdr__id"
                                                v-show="showIDCol"
                                            >
                                                <v-sorter
                                                    :paginator="apiPaginator"
                                                    name="ImportantDates.id"
                                                    @sort="
                                                        $handleSorting($event)
                                                    "
                                                    >{{
                                                        $t(
                                                            "important_dates.tbl_hdr_ID"
                                                        )
                                                    }}</v-sorter
                                                >
                                            </v-th>
                                            <v-th class="hdr__date"
                                                ><v-sorter
                                                    :paginator="apiPaginator"
                                                    name="ImportantDates.date_start"
                                                    @sort="
                                                        $handleSorting($event)
                                                    "
                                                    >{{
                                                        $t(
                                                            "important_dates.tbl_hdr_dates"
                                                        )
                                                    }}</v-sorter
                                                >
                                            </v-th>
                                            <v-th
                                                ><v-sorter
                                                    :paginator="apiPaginator"
                                                    name="ImportantDates.description"
                                                    @sort="
                                                        $handleSorting($event)
                                                    "
                                                    >{{
                                                        $t(
                                                            "important_dates.tbl_hdr_description"
                                                        )
                                                    }}</v-sorter
                                                >
                                            </v-th>

                                            <v-th v-if="false"
                                                ><v-sorter
                                                    :paginator="apiPaginator"
                                                    name="ImportantDates.count_journals"
                                                    @sort="
                                                        $handleSorting($event)
                                                    "
                                                    ><i
                                                        class="far fa-comments"
                                                    ></i
                                                ></v-sorter>
                                            </v-th>

                                            <v-th class="text-center"></v-th>
                                        </v-tr>
                                    </v-thead>
                                    <v-tbody>
                                        <v-tr
                                            v-for="l in dates"
                                            :key="l.id"
                                            :class="{
                                                'date-is-past': isPast(l)
                                            }"
                                        >
                                            <v-td v-show="showIDCol">
                                                {{ l.project_id }}-DT-{{
                                                    l.id_padded
                                                }}
                                            </v-td>
                                            <v-td>
                                                <template v-if="l.date_end">
                                                    {{
                                                        $d(
                                                            new Date(
                                                                l.date_start
                                                            ),
                                                            "short"
                                                        )
                                                    }}
                                                    -
                                                    {{
                                                        $d(
                                                            new Date(
                                                                l.date_end
                                                            ),
                                                            "short"
                                                        )
                                                    }}
                                                </template>
                                                <template v-else>
                                                    {{
                                                        $d(
                                                            new Date(
                                                                l.date_start
                                                            ),
                                                            "short"
                                                        )
                                                    }}
                                                </template>
                                            </v-td>
                                            <v-td>
                                                <v-inline-edit
                                                    :text="l.description"
                                                    @save="
                                                        updateText(l, $event)
                                                    "
                                                    :saving="suSaving"
                                                    :error="suError"
                                                />
                                            </v-td>

                                            <v-td v-if="false">
                                                <v-context-comments
                                                    context="important_date_id"
                                                    :context-id="l.id"
                                                    :count="l.count_journals"
                                                />
                                            </v-td>

                                            <v-td
                                                class="text-center hdr__action"
                                                ><i
                                                    class="far m-click fa-pencil fa-lg"
                                                    @click="setContext(l)"
                                                ></i
                                            ></v-td>
                                        </v-tr>
                                    </v-tbody>
                                </v-table>

                                <div class="mt-4 ml-2">
                                    <base-button
                                        size="sm"
                                        type="link"
                                        @click="setContext({ empty: true })"
                                        ><i class="far fa-plus"></i>
                                        {{
                                            $t("important_dates.add_date")
                                        }}</base-button
                                    >
                                </div>

                                <div
                                    class="paginator"
                                    v-if="meta.pagination.total_pages > 1"
                                >
                                    <base-pagination
                                        :page-count="
                                            meta.pagination.total_pages
                                        "
                                        :per-page="meta.pagination.per_page"
                                        :value="meta.pagination.current_page"
                                        @input="$handlePagination($event)"
                                    />
                                </div>
                            </template>
                            <template v-else>
                                <div class="mx-4 alert alert-warning">
                                    {{ $t("important_dates.no_dates_found") }}
                                </div>
                                <div class="mt-4 ml-2">
                                    <base-button
                                        size="sm"
                                        type="link"
                                        @click="setContext({ empty: true })"
                                        ><i class="far fa-plus"></i>
                                        {{
                                            $t("important_dates.add_date")
                                        }}</base-button
                                    >
                                </div>
                            </template>
                        </card>
                    </template>
                </div>
            </div>
        </div>

        <portal to="modals">
            <v-important-date-form
                @close="showForm = close"
                @close-reload="closeReload"
                :context="context"
                :project-id="project_id"
                v-if="showForm"
            />
        </portal>
    </div>
</template>

<style lang="scss">
.v-important-dates {
    .date-is-past {
        td {
            color: $gray-600;
            background-color: #fafafa;
            //1color: $gray-700 !important;
        }
    }

    .hdr__id {
        width: 150px;
    }

    .hdr__action {
        width: 100px;
    }

    .hdr__date {
        width: 200px;
    }
}
</style>
